import FavoriteButton from "../FavoriteButton";

interface OldImageCardProps {
  imageUrl: string;
  imagePreview: string;
  assetId?: string;
  isFavorite?: boolean;
  toggleFavoriteCallback?: () => void;
}

export default function OldImageCard({ imageUrl, imagePreview, assetId, isFavorite = false, toggleFavoriteCallback }: OldImageCardProps) {
  return (
    <div class="component template" data-component="image">
      <div class="image" data-component="image" data-path-original={imageUrl} data-id={assetId}>
        <picture>
          <source srcSet={imagePreview} type="image/jpg" />
          <img loading={'lazy'} style="width: 100%; height: 100%;" className="img" src={imagePreview} />
        </picture>
        {assetId && <FavoriteButton assetId={assetId} type="stock-photo" isFavorite={isFavorite} callback={toggleFavoriteCallback} />}
      </div>
    </div>
  )
} 